import styled, { css } from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { getTextTokenPreset, getToken } from '@optimus-web/common';
import { Icon } from '../Icon';
import { getTypographyOptions } from '../typography/helpers';
import { InteractionState } from '../utils/enums';
import { getStyles, getTextDecoration } from './getLinkStyles';
import { colorTokens } from './tokenConfig';
import { LinkProps } from './types';

export const LinkStyled = styled.a<LinkProps>`
    ${(props) => props.theme.typography.fontFamily && `font-family: ${props.theme.typography.fontFamily};`}
    display: inline;

    color: ${(props) => getStyles(props, colorTokens)};

    cursor: pointer;
    background: transparent;
    border: none;
    padding: 0;

    ${getTextTokenPreset('BODY_L')};
    font-size: inherit;
    font-weight: inherit;

    ${({ standalone, size }) =>
        standalone &&
        size === 'small' &&
        css`
            ${getTextTokenPreset('BODY_M')};
        `}

    ${({ standalone, strong }) =>
        standalone &&
        strong &&
        css`
            font-weight: ${getToken(TokenName.FONT_WEIGHT_500)};
        `}

    ${({ disabled }) =>
        disabled &&
        css`
            cursor: not-allowed;
        `}

    &:focus-visible {
        outline: none;
        box-shadow: ${getToken(TokenName.FOCUS_OFFSET)};
        border-radius: ${getToken(TokenName.BORDER_RADIUS_50)}px;
    }

    &:hover {
        color: ${(props) => getStyles(props, colorTokens, InteractionState.Hover)};
    }

    &:active {
        color: ${(props) => getStyles(props, colorTokens, InteractionState.Active)};
    }

    ${getTextDecoration}
    ${getTypographyOptions}
`;

export const LinkIcon = styled(Icon)`
    margin-left: ${getToken(TokenName.SPACING_100)}px;
    vertical-align: middle;
`;

export const StandaloneContainer = styled.div`
    display: block;
    width: 100%;
`;
